import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="game-search"
export default class extends Controller {
  static targets = ["input", "game"]

  // Game ----------------------
  search() {
    const searchString = this.inputTarget.value.toLowerCase()

    this.gameTargets.forEach((game) => {
      const gameName = game.innerText.toLowerCase()
      const checkbox = game.querySelector('input[type="checkbox"]')

      if (gameName.includes(searchString) || checkbox.checked) {
        game.style.display = "flex"
      } else {
        game.style.display = "none"
      }
    })
  }

  hideGameList() {
    this.gameTargets.forEach((game) => {
      const checkbox = game.querySelector('input[type="checkbox"]')

      if (checkbox.checked) {
        game.style.display = "flex"
      } else {
        game.style.display = "none"
      }
    })
  }
}
